import { RecordVisibilitiesPage } from '@salescore/client-feature-setting'
import { createFileRoute } from '@tanstack/react-router'
import type { ReactElement } from 'react'

const Page = (): ReactElement => <RecordVisibilitiesPage />

export const Route = createFileRoute('/o/$organizationId/v2/settings/record_visibilities')({
  component: Page,
})
